angular
  .module('jrPagination', ['jrConfig', 'jrUtil', 'jrCommonService'])
  .controller('PaginationCtrl', [
    'Messages',
    '$scope',
    '$timeout',
    '$element',
    function (Messages, $scope, $timeout, $element) {
      const el = $element[0];
      let elPageLinks;
      let elBtnPrev;
      let elBtnNext;
      let elBtnPrevLabel;
      let elBtnNextLabel;
      $timeout(() => {
        elPageLinks = [...el.querySelectorAll('a[href]:not([id="pag-prev"],[id="pag-next"])')];
        elPageLinks.forEach((elPageLink) => {
          let pageNumber;
          try {
            [pageNumber] = elPageLink.id.split('pag-').slice(-1);
          } catch (e) {
            pageNumber = null;
          }
          let label;
          if (pageNumber) {
            label = `${Messages.PaginationItemPageLabelPrefix || 'Page'} ${pageNumber}`;
          } else if (elPageLink.classList.contains('current')) {
            label = `${Messages.PaginationItemCurrentLabel || 'Current Page'}`;
            elPageLink.setAttribute('aria-current', 'page');
          } else if (elPageLink.classList.contains('first')) {
            label = `${Messages.PaginationItemPageLabelPrefix || 'Page'} 1`;
          }
          elPageLink.setAttribute('title', label);
          elPageLink.setAttribute('aria-label', label);
        });

        elBtnPrev = el.querySelector('[id="pag-prev"]');
        elBtnNext = el.querySelector('[id="pag-next"]');
        if (elBtnPrev) {
          const label = Messages.PaginationItemPreviousLabel || 'Previous page';
          elBtnPrevLabel = elBtnPrev.firstElementChild;
          elBtnPrev.setAttribute('title', label);
          elBtnPrev.setAttribute('aria-label', label);
          elBtnPrevLabel.classList.add('sr-only');
          elBtnPrevLabel.textContent = label;
        }

        if (elBtnNext) {
          const label = Messages.PaginationItemNextLabel || 'Next page';
          elBtnNextLabel = elBtnNext.firstElementChild;
          elBtnNext.setAttribute('title', label);
          elBtnNext.setAttribute('aria-label', label);
          elBtnNextLabel.classList.add('sr-only');
          elBtnNextLabel.textContent = label;
        }
      });
    },
  ]);
